import React, { useState, useEffect } from "react";
import { API_BASE } from "../utils/draftutils";
import { useOutletContext } from "react-router-dom";

export default function VisualizzaProposte() {
  const { username } = useOutletContext();

  const [proposte, setProposte] = useState([]);
  const [error, setError] = useState("");
  const [ritiroId, setRitiroId]   = useState(null);  
  const [confirmOpen, setConfirmOpen] = useState(false);

 useEffect(() => {
  const fetchProposte = async () => {
    try {
      const res = await fetch(
        `${API_BASE}/api/proposte/ricevi-proposte`,
        { credentials: "include" }   
      );
      if (!res.ok) throw new Error("Errore nel recupero delle proposte");
      const data = await res.json();
      setProposte(Array.isArray(data) ? data : []);
    } catch (e) {
      setError(e.message);
    }
  };
  fetchProposte();
}, []);  


  const ritira = async () => {
    try {
      const res = await fetch(`${API_BASE}/api/proposte/ritira`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ username, propostaId: ritiroId }),
      });
      if (!res.ok) throw new Error("Errore nel ritiro della proposta");

      // sposta localmente la proposta in RITIRATA
      setProposte((prev) =>
        prev.map((p) =>
          p.id === ritiroId ? { ...p, stato: "RITIRATA" } : p
        )
      );
      setConfirmOpen(false);
      setRitiroId(null);
    } catch (e) {
      setError(e.message);
      setConfirmOpen(false);
    }
  };

  const propostePerStato = {
    APERTA: [],
    CHIUSA: [],
    RITIRATA: [],
  };
  proposte.forEach((p) => {
    if (propostePerStato[p.stato]) propostePerStato[p.stato].push(p);
  });

  const labelStato = {APERTA: "APERTE", CHIUSA: "CHIUSE", RITIRATA: "RITIRATE"};
  const classiStato = {APERTA: "bg-warning-subtle border border-warning", 
                      CHIUSA: "bg-success-subtle border border-success",
                      RITIRATA: "bg-danger-subtle border border-danger"};

  return (
    <div style={{ padding: 20 }}>
      <h2>LE MIE PROPOSTE</h2>
      <hr className="my-4" />
      {error && <p style={{ color: "red" }}>{error}</p>}

      {["APERTA", "CHIUSA", "RITIRATA"].map((stato) => (
        <div key={stato} style={{ marginTop: 30 }}>
          <h4>{labelStato[stato]}</h4>
          {propostePerStato[stato].length === 0 ? (
            <p>Nessuna proposta {stato.toLowerCase()}.</p>
          ) : (
            <ul className="list-group">
              {propostePerStato[stato].map((p) => (
                <li
                  key={p.id}
                  className={`list-group-item d-flex justify-content-between align-items-center ${classiStato[p.stato]}`}
                >
                  {/* descrizione sintetica */}
                  <span>
                    Offro&nbsp;<strong>{p.oreOfferte}</strong>&nbsp;h di&nbsp;
                    <strong>{p.fogliaOffertaNome}</strong>&nbsp;in cambio di&nbsp;
                    <strong>{p.oreRichieste}</strong>&nbsp;h di&nbsp;
                    <strong>{p.fogliaRichiestaNome}</strong>&nbsp;—{" "}
                    <em>creata il {new Date(p.timestamp).toLocaleString()}</em>
                  </span>

                  {/* bottone ritiro solo per APERTA */}
                  {stato === "APERTA" && (
                    <button
                      className="btn btn-sm btn-danger"
                      onClick={() => {
                        setRitiroId(p.id);
                        setConfirmOpen(true);
                      }}
                    >
                      Ritira
                    </button>
                  )}
                </li>
              ))}
            </ul>
          )}
        </div>
      ))}

      {/* MODAL DI CONFERMA */}
      {confirmOpen && (
        <div
          className="modal fade show"
          style={{ display: "block", background: "rgba(0,0,0,.5)" }}
          onClick={() => setConfirmOpen(false)}
        >
          <div
            className="modal-dialog modal-dialog-centered"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-content p-4 text-center">
              <div className="modal-body">
                <p className="mb-4">Sei sicuro di voler ritirare questa proposta?</p>
                <div className="d-flex justify-content-center gap-3">
                  <button
                    className="btn btn-secondary"
                    onClick={() => setConfirmOpen(false)}
                  >
                    Annulla
                  </button>
                  <button className="btn btn-danger" onClick={ritira}>
                    Ritira
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
